import { 
  loadRecommendationsEvents,
  loadRecommendationsPlaces, 
  loadRecommendationsRoutes 
} from '@common/redux/slices/recommendation.slice';
import { reduxWrapper } from '@common/redux/store';
import { News } from '@kursk/components/pages/News/News'
import { loadEntitiesFromQuery } from '@kursk/utils/loadEntitiesFromQuery';
import React from 'react';

export default function NewsPage() {
  return <News />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await Promise.all([
    loadEntitiesFromQuery('news', query, store),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadRecommendationsRoutes({})),
    store.dispatch(loadRecommendationsPlaces({ locales: query.locales })),
  ]);
  
  return { props: {} };
})